import * as React from 'react';

import type { DescriptionPage_DifficultyLevel as DifficultyLevel } from '__generated__/graphql-types';

import { Hidden } from '@coursera/cds-core';

import DesktopEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/DesktopEntityCard';
import MobileEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/MobileEntityCard';

export type ArticleRichEntityCardProps = {
  ctaHref: string;
  ctaLabel?: string;
  ctaAriaLabel: string;
  imageSrc: string;
  imageAlt: string;
  title: string;
  subtitle?: string;
  cardMetaData: {
    entityType: string;
    level: DifficultyLevel | null;
    durationInMonths?: number;
    durationInHours?: number;
    skills?: string;
    averageFiveStarRating?: string;
    ratingCount?: number | null;
    totalEnrollmentCount?: string;
  };
};

type Props = ArticleRichEntityCardProps;

export const ArticleRichEntityCard = (props: Props) => {
  return (
    <React.Fragment>
      <Hidden smUp>
        <MobileEntityCard {...props} />
      </Hidden>
      <Hidden xsDown>
        <DesktopEntityCard {...props} />
      </Hidden>
    </React.Fragment>
  );
};

export default ArticleRichEntityCard;
